(function () {
  'use strict';

  var KEY = 'byju:favoritos';
  var MAX = 60;
  var HANDLE = /^[\p{L}\p{N}][\p{L}\p{N}_-]*$/u;
  var byju = (window.byju = window.byju || {});
  var strings = (byju.strings && byju.strings.wishlist) || {};

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(isHandle).slice(0, MAX) : [];
    } catch (e) {
      return [];
    }
  }

  function isHandle(value) {
    return typeof value === 'string' && value.length < 256 && HANDLE.test(value);
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {

    }
    sync();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handles: list } }));
  }

  function has(handle) {
    return read().indexOf(handle) > -1;
  }

  function toggle(handle) {
    var list = read();
    var index = list.indexOf(handle);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.unshift(handle);
    }
    write(list);
    return index === -1;
  }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(list.length);
      el.setAttribute('data-count', String(list.length));
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var active = list.indexOf(button.getAttribute('data-handle')) > -1;
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', button.getAttribute(active ? 'data-label-remove' : 'data-label-add'));
      var text = button.querySelector('[data-wishlist-text]');
      if (text) text.textContent = text.getAttribute(active ? 'data-text-remove' : 'data-text-add');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element && event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    var handle = button.getAttribute('data-handle');
    if (!isHandle(handle)) return;
    var added = toggle(handle);
    if (byju.toast) byju.toast(added ? strings.added : strings.removed);
  });

  window.addEventListener('storage', function (event) {
    if (event.key === KEY) sync();
  });

  byju.wishlist = { read: read, has: has, toggle: toggle, sync: sync };

  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.loading = this.querySelector('[data-wishlist-loading]');
      this.count = this.querySelector('[data-wishlist-page-count]');
      this.clear = this.querySelector('[data-wishlist-clear]');
      if (this.clear) {
        this.clear.addEventListener('click', function () {
          write([]);
        });
      }
      this.render();
      document.addEventListener('wishlist:change', this.onChange.bind(this));
    }

    onChange() {
      var handles = read();
      Array.prototype.slice.call(this.grid.children).forEach(function (item) {
        if (handles.indexOf(item.getAttribute('data-handle')) === -1) item.remove();
      });
      this.updateState();
    }

    updateState() {
      var total = this.grid.children.length;
      this.empty.hidden = total > 0;
      this.grid.hidden = total === 0;
      if (this.clear) this.clear.hidden = total === 0;
      var toolbar = this.querySelector('.wishlist__toolbar');
      if (toolbar) toolbar.hidden = total === 0;
      document.querySelectorAll('[data-show-when-wishlist-empty]').forEach(function (el) {
        el.hidden = total > 0;
      });
      document.querySelectorAll('[data-hide-when-wishlist-empty]').forEach(function (el) {
        el.hidden = total === 0;
      });
      if (this.count) {
        this.count.textContent = total ? (strings.count || '').replace('__COUNT__', String(total)) : '';
      }
    }

    fetchItem(handle) {
      var url = (byju.routes && byju.routes.root ? byju.routes.root : '/') + 'products/' + encodeURIComponent(handle) + '?section_id=wishlist-item';
      return fetch(url)
        .then(function (response) {
          if (response.status === 404) return { handle: handle, missing: true };
          if (!response.ok) throw new Error(String(response.status));
          return response.text().then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return { handle: handle, node: doc.querySelector('[data-wishlist-item]') };
          });
        })
        .catch(function () {
          return { handle: handle, failed: true };
        });
    }

    render() {
      var handles = read();
      if (!handles.length) {
        this.loading.hidden = true;
        this.updateState();
        return;
      }
      this.loading.hidden = false;
      Promise.all(handles.map(this.fetchItem.bind(this))).then(
        function (results) {
          var missing = [];
          results.forEach(
            function (result) {
              if (result.missing) {
                missing.push(result.handle);
              } else if (result.node) {
                this.grid.appendChild(document.importNode(result.node, true));
              }
            }.bind(this)
          );
          if (missing.length) {
            write(read().filter(function (h) {
              return missing.indexOf(h) === -1;
            }));
          }
          this.loading.hidden = true;
          this.updateState();
          sync();
          if (byju.observeReveal) byju.observeReveal(this.grid);
        }.bind(this)
      );
    }
  }

  if (!customElements.get('wishlist-page')) customElements.define('wishlist-page', WishlistPage);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('shopify:section:load', sync);
})();
